.t{width:100%;}